import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import type { MinimalWave } from '@/contexts/wave/hooks/useEnhancedWavesList';
import { WaveAvatar } from './WaveAvatar';
import { WaveTooltip, WaveTooltipPlacement } from './WaveTooltip';
interface CollapsedWaveProps {
  readonly formattedWaveName: string;
  readonly haveNewDrops: boolean;
  readonly href: string;
  readonly isActive: boolean;
  readonly isDropWave: boolean;
  readonly onMouseEnter: () => void;
  readonly showTooltip: boolean;
  readonly tooltipId: string;
  readonly tooltipPlacement: WaveTooltipPlacement;
  readonly wave: MinimalWave;
}
export const CollapsedWave = t0 => {
  const $ = _c(22);
  const {
    formattedWaveName,
    haveNewDrops,
    href,
    isActive,
    isDropWave,
    onMouseEnter,
    showTooltip,
    tooltipId,
    tooltipPlacement,
    wave
  } = t0;
  const t1 = `tw-group tw-flex tw-items-center tw-justify-center tw-py-2 tw-transition-all tw-duration-200 tw-ease-out ${isActive ? "tw-bg-iron-700/60 desktop-hover:hover:tw-bg-iron-700/70" : "desktop-hover:hover:tw-bg-iron-800/70"}`;
  let t2;
  if ($[0] !== showTooltip || $[1] !== tooltipId) {
    t2 = showTooltip ? {
      "data-tooltip-id": tooltipId
    } : {};
    $[0] = showTooltip;
    $[1] = tooltipId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = !isActive && haveNewDrops;
  let t4;
  if ($[3] !== isActive || $[4] !== isDropWave || $[5] !== t3 || $[6] !== wave) {
    t4 = <div className="tw-relative"><WaveAvatar isActive={isActive} isDropWave={isDropWave} showNewDropsBadge={t3} wave={wave} /></div>;
    $[3] = isActive;
    $[4] = isDropWave;
    $[5] = t3;
    $[6] = wave;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== href || $[9] !== onMouseEnter || $[10] !== t2 || $[11] !== t4) {
    t5 = <Link href={href} onMouseEnter={onMouseEnter} className="tw-flex tw-items-center tw-justify-center tw-no-underline" {...t2}>{t4}</Link>;
    $[8] = href;
    $[9] = onMouseEnter;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== formattedWaveName || $[14] !== showTooltip || $[15] !== tooltipId || $[16] !== tooltipPlacement) {
    t6 = showTooltip && <WaveTooltip id={tooltipId} place={tooltipPlacement}>{formattedWaveName}</WaveTooltip>;
    $[13] = formattedWaveName;
    $[14] = showTooltip;
    $[15] = tooltipId;
    $[16] = tooltipPlacement;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t1 || $[19] !== t5 || $[20] !== t6) {
    t7 = <div className={t1}>{t5}{t6}</div>;
    $[18] = t1;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
};